import { z } from '@/utils/zod'

export const StaticPresenterSchema = z.object({
    type: z.literal('static'),
})

export type StaticPresenter = z.infer<typeof StaticPresenterSchema>
